export default __webpack_public_path__ + "static/media/45d7204799c8794d28afb9cb2ae9285f1581617926976.3c8ff8fd.webp";